import { authEndpoint, infiniteEndpoint } from 'api';

import { EASParams } from 'utils/EASTypes';
import { PrefixFromPersonType } from 'utils/enumMaps';

import { Backend } from './endpoints';

import { api } from '.';

// Company

export const useLoggedInCompany = authEndpoint<
	Backend.Company,
	[isAdmin?: boolean]
>(['company', 'logged-in'], (api, isAdmin) =>
	isAdmin
		? (new Promise(resolve => resolve({ data: {} })) as never)
		: api.get('companies/logged-in'),
);

export const useCompany = authEndpoint<Backend.CompanyDetail, [id: string]>(
	['company'],
	(api, id) => api.get(`companies/${id}/dto`),
	{ refetchOnWindowFocus: false, retry: 2 },
);

// Companies

export const useCompanies = infiniteEndpoint<
	Backend.CompanyDetail,
	[json: EASParams]
>(['companies'], (api, json) => api.post('companies/dto', { json }));

// Edit

export const updateCompanyProfile = (
	companyId: string,
	json: Backend.CompanyUpdate,
	personType: Backend.CommonPersonType = 'RECRUITER',
) =>
	api(
		PrefixFromPersonType[personType ?? 'PUBLIC'],
	).put(`companies/${companyId}/update`, { json });

export const publishCompany = (
	companyId: string,
	personType: Backend.CommonPersonType = 'RECRUITER',
) =>
	api(PrefixFromPersonType[personType ?? 'PUBLIC']).put(
		`companies/${companyId}/publish`,
	);

// Activation

export const companiesActivate = (companyId: string) =>
	api().put(`companies/${companyId}/activate`);

export const companiesDeactivate = (companyId: string) =>
	api().put(`companies/${companyId}/deactivate`);

// Active licence

export const useCompanyActiveLicence = authEndpoint<
	Backend.CompanyActiveProductDto,
	[isAdmin?: boolean]
>(
	['active-license'],
	(api, isAdmin) =>
		isAdmin
			? (new Promise(resolve => resolve({ data: {} })) as never)
			: api.get('purchased-products/logged-in-company/active-license'),
	{
		staleTime: 36000,
	},
);

export const useCompanyPurchasedProducts = authEndpoint<
	Backend.PurchasedProduct[],
	[isAdmin?: boolean]
>(
	['purchased-products', 'logged-in-company'],
	(api, isAdmin) =>
		isAdmin
			? (new Promise(resolve => resolve({ data: {} })) as never)
			: api.get('purchased-products/logged-in-company'),
	{
		staleTime: 36000,
	},
);

// Delete company by admin
export const deleteCompany = (companyId: string) =>
	api().put(`admin/companies/${companyId}/withdraw-gdpr`);

// Admin export

export const exportCompanies = (params: EASParams) =>
	api()
		.post(`admin/companies/export`, {
			searchParams: { reportType: 'CSV' },
			json: { ...params, size: -1 },
		})
		.blob();

// Follow

export const studentFollow = (studentId: string) =>
	api().put(`company/students/${studentId}/add-student-to-favorite`);

export const studentUnfollow = (studentId: string) =>
	api().delete(`company/students/${studentId}/remove-student-from-favorite`);
